import React, { Component } from 'react';

class Intro extends Component {
  render() {
    return (
      <div className="left">
        <div className="bg-img"></div>
        <div className="left-inner">
          <div className="info">
            <picture>
              <source srcset="img/me.webp" type="image/webp"/> 
              <img className="profilePic" src="img/me.jpg" alt="Ashwin Kumar (Avatar)"/>
            </picture>

            <h2 className="name">{this.props.name}</h2>
            <div className="subtext">{this.props.subtext}</div>
            <div className="jobStatus">{this.props.jobStatus}</div>
            <div className="social-links">
              <a title="Ashwin Kumar Twitter" href={this.props.twitterURL} target="_blank" rel="noopener noreferrer">
                <img className="icon" alt="Twitter: @ashwinkumar" src="img/social/twitter.svg" />
              </a>
              <a title="Ashwin Kumar Instagram" href={this.props.instaURL} target="_blank" rel="noopener noreferrer">
                <img className="icon" alt="Instagram: @ashwinnaidu" src="img/social/instagram.svg" />
              </a>
              <a title="Ashwin Kumar GitHub" href={this.props.githubURL} target="_blank" rel="noopener noreferrer">
                <img className="icon" alt="GitHub: @ashwinnaidu" src="img/social/github.svg" />
              </a>
              <a title="Ashwin Kumar Linkedin" href={this.props.linkedinURL}  target="_blank" rel="noopener noreferrer">
                <img className="icon" alt="LinkedIn: @ashwinnaidu" src="img/social/linkedin.svg" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/app/components/intro.js